define('shoptheme/components/layout/story',[
	"cartware/components/_base",
	"jquery",
	"cartware/jquery/bem",
	"enquire",
	"json!shoptheme/etc/breakpoints.json",
], function(
	Component,
	$,
	BEM,
	enquire,
	BreakPoints
) {
	return Component.create({
		//var
		init: function() {

			this.blocks = BEM.block('story-item');
			this.container = this.blocks.getElements('container');
			this.mobileImage = this.container.attr('data-mobile-image');
			this.desktopImage = this.container.attr('data-desktop-image');


			//this.story();
		},

		story: function() {

			var _self = this;

			enquire.register('(min-width: ' + (BreakPoints.mobile + 1) + 'px)', {
				match: function() {
					_self.container.css('background-image', 'url('+_self.desktopImage+')');
				},
				unmatch: function() {
					_self.container.css('background-image', 'url('+_self.mobileImage+')');
				}
			}, true);

		}
	});

});
